import { Component, OnInit, ViewChild, ElementRef, Renderer2 } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormDataService } from 'src/app/shared/form-data.service';
import { FormGroup } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { ConfigService } from 'src/app/shared/config.service';
import { Observable } from 'rxjs';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { ModalComponent } from 'src/app/main/modal/modal.component';
import { LoaderService } from 'src/app/core/loader/loader.service';

@Component({
  selector: 'app-photos',
  templateUrl: './photos.component.html',
  styleUrls: ['./photos.component.scss']
})
export class PhotosComponent implements OnInit {

  photosConf: any;
  photosForm: FormGroup;
  contentDetail: any;
  additionalPhotosConf: any;
  noOfDesiredMandatoryImages : any;  
  hasAdditionalPhotos:boolean;
  enableSubmitBtn:boolean;
  msg:string;
  desiredImageTabTitle : string;
  additionalImageTabTitle : string;
  noOfAdditionalMandatoryImages : any;
  enablePerspective = "";
  isPerspectiveCheckedFirstTime: boolean;
  easyClaimType: string;
  supportingFileFormatMsg: string;
  initialMsg: string;
  submitErrorMsg: any;
  investigationType = "";
  stpDelay: Number;

  @ViewChild('photoError', {static: false}) photoErrorView: ElementRef;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private formDataService: FormDataService,
    private renderer: Renderer2,
    private toastr: ToastrService,
    private configService: ConfigService,
    public matDialog: MatDialog,
    private loaderService: LoaderService
  ) {
    this.contentDetail = this.configService.config.Data.contentDetail;
    this.noOfDesiredMandatoryImages = Number(this.configService.config.Data.images.number_of_desired_mandatory_images);
    this.noOfAdditionalMandatoryImages = Number(this.configService.config.Data.images.number_of_additional_mandatory_images);
    this.enableSubmitBtn = false;
    this.desiredImageTabTitle = this.configService.config.Data.images.desired_images_tab_title;
    this.additionalImageTabTitle = this.configService.config.Data.images.additional_images_tab_title;

    this.enablePerspective = this.configService.config.Data.EnablePerspective;

    if(this.enablePerspective == null || this.enablePerspective == "")
    {
      this.enablePerspective = "no";
    }
    this.isPerspectiveCheckedFirstTime = true;
    this.easyClaimType = this.formDataService.getEasyClaimType();
    this.supportingFileFormatMsg = this.contentDetail.SupportingFileFormatMsg;    

    this.investigationType = this.configService.config.Data.Investigation_type;
    this.stpDelay = this.configService.config.Data.STPDelay;
   }

  ngOnInit() {
   this.photosConf = this.formDataService.getPhotos();
   this.additionalPhotosConf = this.formDataService.getAdditionalPhotos();
   
  this.photosConf.forEach((el,i) => {
    el.imageDataLogo = el.imageData;
    el.imageSideData = el.imageData;
  });

  this.additionalPhotosConf.forEach((el,i) => {
    el.imageDataLogo = el.imageData;
    el.imageSideData = el.imageData;
  });

   this.hasAdditionalPhotos = true;
   if(this.additionalPhotosConf.length <= 0)
   {
     this.hasAdditionalPhotos = false;
   }
   else if(this.additionalPhotosConf.length == 1)
   {
      if(this.additionalPhotosConf[0].i == "")
      {
        this.hasAdditionalPhotos = false;
      }      
   
    }  
    if(this.noOfDesiredMandatoryImages>1)
    {
      this.msg = "Please upload " + this.noOfDesiredMandatoryImages + " required files ";
    }
    else 
    { 
      this.msg = "Please upload " + this.noOfDesiredMandatoryImages + " required file ";
    }

    if(this.noOfAdditionalMandatoryImages > 0)
    {
      if(this.noOfAdditionalMandatoryImages > 1)
      {
        if(this.msg == "")
        {
          this.msg = "Please upload " + this.noOfAdditionalMandatoryImages + " " + this.additionalImageTabTitle + " files ";
        }
        else
        {
          this.msg += "and " + this.noOfAdditionalMandatoryImages + " " + this.additionalImageTabTitle +" files ";
        }
        
      }
      else
      {
        if(this.msg == "")
        {
          this.msg = "Please upload " + this.noOfAdditionalMandatoryImages + " " + this.additionalImageTabTitle + " file ";
        }
        else
        {
          this.msg += "and " + this.noOfAdditionalMandatoryImages  + " " + this.additionalImageTabTitle + " file ";
        }        
      }
    }

    if(this.msg != "")
    {
      this.msg += "before moving forward"
    }

    if ((this.photosConf.every( element => element.valid === true) || this.photosConf.filter(x => x.valid === true).length >= this.noOfDesiredMandatoryImages) &&
    (this.additionalPhotosConf.every( element => element.valid === true) || this.additionalPhotosConf.filter(x => x.valid === true).length >= this.noOfAdditionalMandatoryImages)) {
      this.enableSubmitBtn = true;
    }

    this.initialMsg = this.msg;   
  }


  onPhotoRemoveClick(event, item, i, photoType) {
    event.preventDefault();
    const element: HTMLElement = document.getElementById('imgInput' + i);
    
    if(photoType == "required")
    {
        this.photosConf[i].imageDataLogo = this.photosConf[i].imageSideData;
        this.photosConf[i].valid = false;  
        this.photosConf[i].IsPhotoSideValid = '';
        this.photosConf[i].showRemoveBtn = false;
        this.formDataService.setTimeStampType("p1photo" + (Number(i) + 1) );
    }
    else
    {
      this.additionalPhotosConf[i].imageDataLogo = this.additionalPhotosConf[i].imageSideData
      this.additionalPhotosConf[i].valid = false;  
      this.additionalPhotosConf[i].IsPhotoSideValid = '';
      this.additionalPhotosConf[i].showRemoveBtn = false;
      this.formDataService.setTimeStampType("p1additionalphoto" + (Number(i) + 1) ); 
    }         
        this.msg = this.initialMsg;

        this.formDataService.setTimeStampDateTime(new Date().toUTCString());    
      
      const http$ = this.formDataService.deleteTimeStamp();
      this.enableSubmitBtn = false;
      http$.subscribe(res => {
        const uploadedFilesCount = this.photosConf.filter(x => x.valid === true).length;
        const uploadedAdditionalFilesCount = this.additionalPhotosConf.filter(x => x.valid == true).length;

        if ((this.photosConf.every( element => element.valid === true) || uploadedFilesCount >= this.noOfDesiredMandatoryImages) && 
        (this.additionalPhotosConf.every( element => element.valid === true) || uploadedAdditionalFilesCount >= this.noOfAdditionalMandatoryImages)) {
          this.enableSubmitBtn = true;
          this.msg="You can add more files or click the arrow below to continue";
        }
      }, err => {
        console.log(err);
        
      });


  }


  onItemClick(event, item, i) {
    this.openFileBrowse(event, i);
  }

  openFileBrowse(event: any, i) {
    event.preventDefault();
    const element: HTMLElement = document.getElementById('imgInput' + i);
    element.setAttribute('imageNo', i);
    element.setAttribute('photoType', 'desired');
    element.click();
  }

  onAdditionalPhotoItemClick(event, item, i) {
    this.openAdditionalPhotoFileBrowse(event, i);
  }

  openAdditionalPhotoFileBrowse(event: any, i) {
    event.preventDefault();
    const element: HTMLElement = document.getElementById('imgInput' + i);
    element.setAttribute('imageNo', i);
    element.setAttribute('photoType', 'additional');
    element.click();
  }

  onFileChange(event: any) {
    if (event.target.files && event.target.files[0]) {
      this.enableSubmitBtn = false;
      const files = event.target.files;
      const i = event.target.getAttribute('imageNo');
      const photoType = event.target.getAttribute('photoType');
      var fileType = files[0].type;
      var sideName = event.target.getAttribute('data-sidename');      

      if(this.easyClaimType == 'EasyClaim')
      {       

        if(fileType != 'image/png' && fileType != 'image/gif' && fileType != 'image/jpeg' && fileType != 'image/tiff')
        {
          this.toastr.error(this.supportingFileFormatMsg, 'Validation Error', {
            positionClass: 'toast-center-center',
            timeOut: 3000
          });
          return;
        }
      }
      else
      {
        if(fileType != 'image/png' && fileType != 'image/gif' && fileType != 'image/jpeg' && fileType != 'image/tiff' && 
          fileType != 'application/pdf' && fileType != 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
          && fileType != 'application/msword' && fileType != 'text/plain' && fileType != 'application/vnd.ms-excel' &&
          fileType != 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet')
        {
          this.toastr.error(this.supportingFileFormatMsg, 'Validation Error', {
            positionClass: 'toast-center-center',
            timeOut: 3000
          });
          return;
        }
      }   


      if(photoType == 'desired')
      {
        this.photosConf[i].filename = files[0].name;
        this.photosConf[i].valid = true;  
        this.photosConf[i].sideName = sideName;  
        this.photosConf[i].IsPhotoSideValid = '';
        this.photosConf[i].showRemoveBtn = true;
        this.formDataService.setTimeStampType("p1photo" + (Number(i) + 1) );

      }
      else
      {
        this.additionalPhotosConf[i].filename = files[0].name; 
        this.additionalPhotosConf[i].valid = true;
        this.additionalPhotosConf[i].sideName = sideName;  
        this.additionalPhotosConf[i].IsPhotoSideValid = '';
        this.additionalPhotosConf[i].showRemoveBtn = true;
        this.formDataService.setTimeStampType("p1additionalphoto" + (Number(i) + 1) ); 
      }

      var self = this;
      

      //from here
      // const reader = new FileReader();
      // reader.readAsDataURL(files[0]);
      // reader.onload = (_event) => {

      //   if(photoType == 'desired')
      //   {
      //     console.log(reader.result);
      //     this.photosConf[i].imageData = reader.result;
      //     this.photosConf[i].valid = true;
      //     this.photosConf[i].filename = files[0].name;                    
      //   }
      //   else
      //   {
      //     this.additionalPhotosConf[i].imageData = reader.result;
      //     this.additionalPhotosConf[i].valid = true;
      //     this.additionalPhotosConf[i].filename = files[0].name;        
      //   }
        
      //   event.target.value = '';
      // }
      //to here


if(fileType.includes("image"))
{
      //comment1      
      // Create an image
    const img = new Image();
    // Create a file reader
    var reader = new FileReader();
    reader.readAsDataURL(files[0]);
    // Set the image once loaded into file reader
    reader.onload  = function(e)
    {
        img.src = (e.target as any).result;      
        event.target.value = '';

        img.onload = function () {
            var canvas = document.createElement("canvas");

            var width = img.width;
            var height = img.height;
            if(width < 200 || height < 200)
            {
              self.toastr.error('Please upload image of size greater than 200 X 200.', 'Validation Error', {
                positionClass: 'toast-center-center',
                timeOut: 3000
              });
              return;
            }

            if(width > 3000 && height > 3000)
            {
              width = width/3;
              height = height/3;
            }
            else if(width > 1000 && height > 1000)
            {
              width = width/2;
              height = height/2;
            }
           
            canvas.width = width;
            canvas.height = height;
            var ctx = canvas.getContext("2d");
            ctx.drawImage(img, 0, 0, width, height);

            var  dataurl = canvas.toDataURL("image/jpeg");
            dataurl = dataurl.replace("data:image/jpeg;base64,", "");

            if(photoType == 'desired')
            {
              self.photosConf[i].imageData = dataurl;
              self.photosConf[i].imageDataLogo = dataurl;     
              self.photosConf[i].isImage = true;  
              self.photosConf[i].contentType = "image/jpeg";                
            }
            else
            {
              self.additionalPhotosConf[i].imageData = dataurl;
              self.additionalPhotosConf[i].imageDataLogo = dataurl;  
              self.additionalPhotosConf[i].isImage = true;   
              self.additionalPhotosConf[i].contentType = "image/jpeg";                                  
            } 
            
            //const uploadedFilesCount = self.photosConf.filter(x => x.valid === true).length;
            //if (self.photosConf.every( element => element.valid === true) || uploadedFilesCount >= self.noOfDesiredMandatoryImages) {
            //  self.enableSubmitBtn = true;
            //  self.msg="You can add more images or click the arrow below to continue";
           // }
         
            console.log(dataurl);
            
        } // img.onload
        //reader.readAsDataURL(files[0]);
        if(event.target.files[0]){
          reader.readAsDataURL(event.target.files[0]);          
        }  
    }
  }
  else
  {

     //from here

    var base64String = '';
    if(fileType == "application/msword" || fileType == "application/vnd.openxmlformats-officedocument.wordprocessingml.document")
    {      
      base64String = "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";
    }
    else if(fileType == "application/vnd.ms-excel" || fileType == "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet")
    {      
      base64String = "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";
    }
    else if(fileType == "application/pdf")
    {      
      base64String = "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";
    }
    else if(fileType == "text/plain")
    {      
      base64String = "iVBORw0KGgoAAAANSUhEUgAAAIAAAACACAQAAABpN6lAAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAAmJLR0QA/4ePzL8AAAAJcEhZcwAACxMAAAsTAQCanBgAAAAHdElNRQflBAwIMTdF+MrsAAAN20lEQVR42u2dfXRU5Z3HP787L0kmmbxAABMIUF4kUHlNABHBGEBFBbesXd2t667b1WJXK9WuQE/rdt16ui/FVuvBHj2eXc/ZbXfxbLsquktFCpV3EggiKALhJRAIEBLyMpNkZu5v/8goybwkd5LJTCB8OYczuc9zf/P8PvfeZ57nub/fvUIv5OZ+9qUaY4yb9RajUEdqDi6M3lgMkSl1UqVbWa/bUxuPcD6Opr+Q9HTHOeygKJN5sox55Kur55YsYKhlA6/pzlbfg8APkg1AgSk4U2Qe36ZUs/rM8c4NreaX+mrbxQPxttuTnaZhu0Ge5Js6LDHOB5vaxgZ9rqxCuI+3kwdgOTuxT+En3KH2RLofbO4+VsqHapbFzaItlsq5FNNA2yzW6u1x7eysK09u0zo5mGeeTTyAEsZxlrapslZnJ8X5dmUxH4/sH+k/nWgAJxiKmS+/0JIkug+Qxi0S8O0d6TuTSACFTKbBaazmoa5OfonTv26UIrMNM1AWDwQWO7Kv8xa52BbwTY2MTKWBGi5IExpeFm2LXPmoIeVDuEnTo7dHM2Slge/FWZ7diQGQSSGt2TyhgyM6X8lv+dA8RJMRkC99aT+OJgqRj6q2/2cGa3eqkcZS+aEWdINA/Gt6i8DSz+DXeYtp2JfxpmaEGfDyX/yMgxoo71VDOqsIvzgeZ42mdtn4Jv45sMbRKwSW+oBCPGS5dLXOCGuCh5/yHKfKNF4/S0G7DMVfJaUM77KaU2YZpr9XfYElADk4kImsInTYG5C1+mNHU2+vw3AVcZwsr05mVjcVnTLLMH1lBb7qvgRQxQ0Y9/JAaG3Zoc+01O6Lu/twggZGaWCM3NntgMspMw0z0GMEFsZzk1mMOChWZ4j7Xl5POX2Q0X0AACYBXKS1+5qawUrbCk27ua8AKHWIS8aEFRzVTQHGcaJPAGTQhnjEb6WuZrCaFYEeIbAA4BPSUJeGd0flgfNpsU0mYlAqXtSvaq22ZrBan/L3AIGlKY0iLnWHbT3hbt3M4T4CYGASHCJYQ+Dm+3w34IoVgSUA6UgaoT1AQC74+sj54DcgJhbPgCCC1frdNld3Pxw9AADYwoZMJr5AnwKIXZrBKuMZX0wIejWrj+HwJA7BSltMCJKzrNGXCNJjQ3DNAQBN51nbM36XtVWbaxAAaAbPGk/7LCG4JgG09wXG060WLoRrFABohq60r9DUaawamACADF1lLnc63mPRAAUAbn5oPpRufMCfD1AAMIjn/Xcu5pUBCwAdwT+eL1rMi5QMTACgU+SF1rx32DxQAQAL5Yk652yKByoAtfGYvdTBHh68egCk0Qr+eM23NFeWe7MmcvnqAWDixDynjXEzWColbsJX2PotgBrccFI+ipc9dXOX31HPtKsFQAU7EY/+XD6Om8nZMiiF0JvqSYjysCqDTZSWFX9LVjG3y+gzDd5SNrBpF7f6dJgMtteErmL1YwBQCqTt9P4FX6VAHF24Bjbs2DVT8mW8TtHhkXBJquacZB7vXD0AAD6Cy2y3VncGAcNIN8bKI/oI7vBysflJCdnW7wHEor1g0lhcwWpp0JWEnzMRrpB+2wn2XGXYPbwhR6zVvgYB3EktUivHBiyAdCqx+bR+wAKwEbgSeTMQAcSm6wCS3YBk6zqAZDcg2boOwEqlhmS3sg9lB5gJDr9Lo4b7NJmGOwIqly9zWoLmEqLi83rcZvwjEu3FiNO8Vf7YPp7oYamq6aG5QWqXv3Eu68NUqc4yqXftMtfNPTaef4svAEnR5bJah8W8+ig6XscnyP12LWFJ24pDu9tjl+Mlw7yPHyQ2+annbdU5+hMzr5iehsVGNCrf0tzoxbEkNUTe3l3tGJMlbqHUxrY4ArBrUdQyUw7LyagtUrJ0GmnBv+qM/bQE647VscFPLbLPuIQowCid+EVHKtVyiGghZioOnaxDoxSmMv3ir17SH1EXLwBETXyU0/oIhyTKD6Wq6TbW6tLgn2+YLxjt3Yip0+TfdSQA75tP0CyAqUzkLUYCSAs/5j+iH2oTeVye12hrgO5c+1O+pSEre70BEF21VNobd0YsGkchVc3yZZi+GNroDQyikgJa9tg+4hsgrfq2nH2Mx5hKCmYAe7CjbZXjzQ35bIxo+QEOkF6pPqIBEIGwlb2eq6uBkATEFaXoLItp63jBLmLEED7lNDtIa+F30gKckV2t/IrhTGQ3LCbvi8oqEC0KWvElNP6wKwBdtKOA9zofhfEy34OTQkZioNs4BeyWqiYyGc5RioZxd+cVyUQNIHoDwDCoj1J0nMuoXvFCU1liulIYjxvFPM1WCbDZ4znBfhaSgsxhcgffJZOLUSw3k5FQOl31AcPlHq2YIYjh0SNp/q1M4DNmilnAENSr9sEyvcNJcotOzC2v4iD/xG9b/R8wl+3CQs6wDU+KbWmHdCuXLmqrcegMxJTKrzRso5oCCqnL0dEqZzEMFtBlslSCAGguL4sXMKjQB9JqYRLCPJvnO/wVfsDeaXicx127y/+WGn7BOJp28y5VAZThnCN1XMf4FLXzuDyEItLAo59uGkc1xRwicz4vkwaIZiZultr1ZCaD9uM2qL1BdkAENzkRcBlyV/FrWy7kMZwD5J4xXzEbR3KUuRwj9Q46ZwCmBDsQJ04TA7BjQiq5uEiwrM3mNMrnzprCbGN9OQKcaOUkwAL2MiiHe6Kk2mtHa1azQ+KrOJ5qmsm9Lc55fLXDttvwITMp6rHRqwkAUGofXdOe7wXANN4n3cG9mp1sNxMFYLQuSGEdX8ySz2NDRnUZqZp0xRWAOuQeR+b84IU9nmp8yO2M6aXZqwcAMNs2zWQsACYl+LNYGppw2b8UbwDZOslkAwDHSEPydEqyXUwsgItSYbISgLE0Y56VeD/4p58D2BH4RHk/aPoPpFzW/xEL+b/XCABp1fUpTZ8H70wfIZc02ITFUIVrAACVbHaSwsHgn3mYmKf4v2Q7mTgAG6nyXVn34ACDsPtZL7XJdjMhAOQy7zX7bqOiw7bPcGCWsyvZbiYEAPvMskw2kM/9zBhSVDCMJfjZjr+Bt6Ut2Y5GU9zu7UlA//fva+FRRlGNlEjBuRchn+G4aflQjjEx2a72MQCqZcMLNDMEF/U22zxuKvpXR90QDAKYJ20b+iuA+F0CW43PqxlHPX5sw7iV6TLVIIcKRmHz67tyKdmu9ikA8fKuz3sKD6XUwQzGkS2LAsYWFvIxTrTfdoTxOgMO61YXBQTYQJqNUnUrLDSHTsePn20Yl3mnf3aElgG0PxHsy4+dJLDBd+YSefjJxxzKfAAmMsvFYxxhOCnoxq5GhMm7S2ANgB3bJeA002mSCB1nE7tc5nF204yBFHMjgLpZ7HWsAarxYp7S8ItAxG4wAlhHNtitcYgvLDtm9xB0jDwpFTPFh001V24NOwXSuN+fepOCKqkdYvXvkxNyvNgAVLPD0/Y0g4dT3YfNmYDa9RuW7gaYhmLl+UpWAUiN5nVbK0OeJXgFi03D7kyqjQfla8FLw7hyz0zz5B/wRd8PQ++XJcH9hFRLB7cm16/kWqhoEQAbeaj7L1b7l/d2I8vQtIj7OXDQzX6xrIZLPdsP823iN7kw9GXZHzdrfSwJ8Gtzazbr42jTKC/jO7JFPMl2rlvnTbnIq/p8Y/NOquJo1w7G1sCfcSuFRH+Gp8koloVEJZj8joqE3cMz9YKU655GTwklvB5fALuVatZ1VWkOvkUs7tyJSYDfyOt7EuT/FX0eZ3sWjuByGuk+fOtqlQUAn0UP6Ep26xMD4NrWdQDJbkCydR1AshuQbF0HkOwGJFvXASS7AcnWdQC92bl/Tg9ia5UFAAYmBMIG/gbOvnqsdu/UiJuAEf7QFQUzEIbHAoAcmqFFQ/Lx1aZD3P1yOuQnH3VECOcNqDcvbG3eAoBactCG8IVYGXMhtYQJyfY3TKfIRjN1RFiBh4ZcQl8EYgHAxwyGCxL+rrsi2zDth2m1d9CMTGVU6HY5a9a3hKVIWXrBQg00cTysYIwsCvCf7ZlQ/UYT2I8zhfs0M6yo0mg+yfTYARzgU2Y26d7Q7ZrKo62jV3Aq2T530Ayy8CC38UehJWJSbvfeEfbSRgsALvE8v0e2S1iqnhaz0pY5hZd4KdmeB7WXADqBv9MhYUUX2WljC4dCNlv6JQvgw3ZZ5vOVkAKRmyTVVr7H6yb+ed2xay556CTWcHv4YEA2B151tV4mNEzBEoA2jnLGeyRDFobVtzOT8faq0+fzA/HM6I1dczBIceu98lNKIrjfwr84d21jcBgAi8OmseTjGSH/rZEe1q1ymvV8qJ9ovdm3L52IIsFIkWEUcTcLIr8CVP6gf2Kvae0UwRYTgEncgBffw6yN9go0adZLUkuTmAkfIavayWYQORoloVQa+Wvfuv2M42hPAUAJ9djc8oo+nGD34gBIXuNpj2cIWyLBicXSVOyF8qbG9haTpEs+0r9sqTwYpTSG2eAo9pP9Gc/Ip8l2KSb39/M9Z+VBSnsP4CRwN2VbeVIOWt8rye7v48mhuycAm6LUiHFGm8VBbjz+QYUUUtBPlwOuOB+QzTw1cufbfK2rWj0xPZH0MXyPP+3P6XByiTf5ma+qu+iPHq1pXCS/jt9zQHLkBvphSpQ0ykb9Pm9g4VWAPT6NS2iCQVoqy5jDsMgRQklw3cM5tulvjM2p9b9mhJU9evN1z7GPc+l6IzczR27UAs0iLSnLrCZeqaOKw+xgpx4t80zC6k/V/wMOM4P6ZGVqNQAAACV0RVh0ZGF0ZTpjcmVhdGUAMjAyMS0wNC0xMlQwODo0OTo1NSswMDowMP7NSxYAAAAldEVYdGRhdGU6bW9kaWZ5ADIwMjEtMDQtMTJUMDg6NDk6NTUrMDA6MDCPkPOqAAAAAElFTkSuQmCC";
    }

      const reader = new FileReader();
      reader.readAsDataURL(files[0]);
      reader.onload = (_event) => {

        var fileBase64Res =  reader.result.toString();
        var base64StringResult = fileBase64Res.substring(fileBase64Res.indexOf(",") + 1);
        if(photoType == 'desired')
        {          
          this.photosConf[i].imageData = base64StringResult;
          this.photosConf[i].valid = true;
          this.photosConf[i].filename = files[0].name;   
          this.photosConf[i].imageDataLogo = base64String;  
          this.photosConf[i].isImage = false;
          this.photosConf[i].contentType = fileType;               
        }
        else
        {
          this.additionalPhotosConf[i].imageData = base64StringResult;
          this.additionalPhotosConf[i].valid = true;
          this.additionalPhotosConf[i].filename = files[0].name;   
          this.additionalPhotosConf[i].imageDataLogo = base64String; 
          this.additionalPhotosConf[i].isImage = false;
          this.additionalPhotosConf[i].contentType = fileType;    
        }
        
        event.target.value = '';
      }
      //to here

  }
      
      this.formDataService.setTimeStampDateTime(new Date().toUTCString());    
      
      const http$ = this.formDataService.submitTimeStamp();
      self.enableSubmitBtn = false;
      http$.subscribe(res => {
        console.log(res);
        const uploadedFilesCount = self.photosConf.filter(x => x.valid === true).length;
        const uploadedAdditionalFilesCount = self.additionalPhotosConf.filter(x => x.valid == true).length;
        if ((self.photosConf.every( element => element.valid === true) || uploadedFilesCount >= self.noOfDesiredMandatoryImages) && 
        (self.additionalPhotosConf.every( element => element.valid === true) || uploadedAdditionalFilesCount >= self.noOfAdditionalMandatoryImages)) {
          self.enableSubmitBtn = true;
          self.msg="You can add more files or click the arrow below to continue";
        }
      }, err => {
        console.log(err);
        
      });

    }
  }


  gotoQuestions() {   
    var perspectiveSides = this.formDataService.perspectiveSides;
    if(perspectiveSides != null && perspectiveSides.length > 0 && this.enablePerspective.toLowerCase() == "yes")
    {    
      this.formDataService.setSubmitDateTime(new Date().toUTCString());         

      const http$ = this.formDataService.checkImageSides();

      http$.subscribe(res => {           
        if(res.IsError == true)
        {
          var errorMsg = res.Messages[0].Message;

          this.toastr.error(errorMsg, 'Error',{
            positionClass: 'toast-center-center',
            timeOut: 2000
          });
          return false;
        }
        else
        {
            var isValidSides = true;
            var invalidImageLabels = "";
            var hasAllImagesPerspectives = true;
            var invalidPerspectiveImageLabels = "";
            var invalidPerspectiveImgLabels = [];
             
            var validDesiredPhotos = this.photosConf.filter(x => x.valid === true);
            for(let i=0; i < validDesiredPhotos.length; i++){
                var imgData1 = validDesiredPhotos[i].imageData;
                console.log("1: "+ validDesiredPhotos[i].filename);
                var resItem = res.Data.find(x => x.FileName == validDesiredPhotos[i].filename);
                console.log("2: "+  resItem.SideName);
                if(resItem == null || resItem.SideName == null || resItem.SideName == '')
                {
                  console.log("3: "+ validDesiredPhotos[i].sideNameLabel);
                  validDesiredPhotos[i].IsPhotoSideValid = 'invalid';
                   hasAllImagesPerspectives = false;
                   invalidPerspectiveImageLabels += validDesiredPhotos[i].sideNameLabel + ",";                   
                }
            }

            console.log("4: "+ hasAllImagesPerspectives+"----"+invalidPerspectiveImageLabels);

            if(hasAllImagesPerspectives == false && this.isPerspectiveCheckedFirstTime == true)
            {
              this.isPerspectiveCheckedFirstTime = false;
              invalidPerspectiveImageLabels = invalidPerspectiveImageLabels.slice(0, -1);
              
              
              this.isPerspectiveCheckedFirstTime = false;
                this.toastr.error("It doesn’t look like there is a visible car on the side: " + invalidPerspectiveImageLabels , '',{
                  positionClass: 'toast-center-center',
                  timeOut: 10000
                }); 

                return;
            }

            for(let i=0; i < validDesiredPhotos.length; i++){
              var imgData1 = validDesiredPhotos[i].imageData;
              
              var resItem = res.Data.find(x => x.FileName == validDesiredPhotos[i].filename);
              if(resItem != null && perspectiveSides.indexOf(validDesiredPhotos[i].sideName) !== -1)
              {
                var sideNameLabelStr=validDesiredPhotos[i].sideNameLabel.toLowerCase().replace("side","").trim();
                console.log("5: ---" + resItem.SideName.toLowerCase() + "----" + validDesiredPhotos[i].sideName.toLowerCase() + "----" + sideNameLabelStr + "-----");
                if(!((resItem.SideName.toLowerCase().trim() == validDesiredPhotos[i].sideName.toLowerCase().trim()) || (resItem.SideName.toLowerCase().trim() == sideNameLabelStr)))
                {
                    console.log("6: ---" + resItem.SideName.toLowerCase() + "----" + validDesiredPhotos[i].sideName.toLowerCase() + "----" + sideNameLabelStr + "-----");
                    isValidSides = false;
                    validDesiredPhotos[i].IsPhotoSideValid = 'invalid';
                    invalidImageLabels += validDesiredPhotos[i].sideNameLabel + ",";
                    invalidPerspectiveImgLabels.push(validDesiredPhotos[i].sideNameLabel);
                }
              }
          }

            
            if(isValidSides == false && this.isPerspectiveCheckedFirstTime == true){
              invalidImageLabels = invalidImageLabels.slice(0, -1);

              this.isPerspectiveCheckedFirstTime = false;

                // this.toastr.error("Image perspective doesn't look like it is from the " + invalidImageLabels + " of the vehicle please try uploading the required perspective.", '',{
                //   positionClass: 'toast-center-center',
                //   timeOut: 10000
                // });   
                
                var errorMessg = "<p style='display: flex; justify-content: center;'>The following images do not look</br>as though they are for the</br>correct area of the vehicle.</br></br>Please retake.</br>";
                for (let i = 0; i < invalidPerspectiveImgLabels.length; i++) {
                  errorMessg +=  invalidPerspectiveImgLabels[i] + "</br>";
                }

                errorMessg += "</p>";

                this.toastr.error(errorMessg , '',{
                  enableHtml: true,
                  positionClass: 'toast-center-center',
                  messageClass: "centerMsgCls",
                  timeOut: 10000
                });

              }
            else{
              this.gotoQuestionsMainMethod();
            }
        }


      }, err => {    
          console.log(err);
          this.toastr.error('Upload proper side images', 'Error',{
            positionClass: 'toast-center-center',
            timeOut: 2000
          });     
      });  
  }
  else
  {
    this.gotoQuestionsMainMethod();
  }  

}



  gotoQuestionsMainMethod() {
    const uploadedFilesCount = this.photosConf.filter(x => x.valid === true).length;
    const uploadedAdditionalFilesCount = this.photosConf.filter(x => x.valid === true).length;
    if ((this.photosConf.every( element => element.valid === true) || uploadedFilesCount >= this.noOfDesiredMandatoryImages) &&
    (this.additionalPhotosConf.every( element => element.valid === true) || uploadedAdditionalFilesCount >= this.noOfDesiredMandatoryImages)) {

      //11 Photo page
      // this.formDataService.setTimeStampType("p1photopagecontinuebtn");
      // this.formDataService.setTimeStampDateTime(new Date().toUTCString());    
    
      // const http$ = this.formDataService.submitTimeStamp();
      // this.enableSubmitBtn = false;
      // http$.subscribe(res => {
      //   this.enableSubmitBtn = true;
      //   this.router.navigate(['../questions'], { relativeTo: this.route });
      // }, err => {
      //   console.log(err);
      //   this.enableSubmitBtn = true;
      // });
      //11 Photo page


      //11 From Question page    
      this.formDataService.setSubmitDateTime(new Date().toUTCString());
      const http$ = this.formDataService.sendData();

      this.openModal();
      this.submitErrorMsg = "";
      this.loaderService.show();

      http$.subscribe(res => {
        this.closeModal();
        this.formDataService.setTimeStampType("p1informationreceived");
        this.formDataService.setTimeStampDateTime(new Date().toUTCString());    
      
        const http$ = this.formDataService.submitTimeStamp();
        http$.subscribe(res => {
         
        }, err => {
          console.log(err);
          
        });

          

        if(res.IsError == true)
        {
          this.submitErrorMsg = res.Messages[0].Message;
        }
        else
        {
          this.matDialog.afterAllClosed.subscribe(result => {

            if(this.investigationType.toLowerCase() == "automatic" && this.stpDelay != null)
            {
              const http$ = this.formDataService.sendAutomaticEmail();
              http$.subscribe(res => {
               
              }, err => {
                console.log(err);
                
              });
            }
          });

          this.formDataService.setEngineeringOutcome(res.EngineeringOutcome);
          
          
            this.router.navigate(['../response'], { relativeTo: this.route});
        }


      }, err => {
        this.closeModal();
        console.log(err);
        this.submitErrorMsg = "Your information was not able to be submitted. Please check your internet connection and try again";
      });  

      //11 From Question page

      

      
    } else {
      console.log('validation error');
      this.toastr.error('Upload required files', 'Validation Error',{
       positionClass: 'toast-center-center',
       timeOut: 2000
      });
      //this.photoErrorView.nativeElement.className = 'bspa alert alert-danger alert-dismissible fade show';
    }
  }

  openModal() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.id = "modal-component";
    dialogConfig.height = "400px";
    dialogConfig.width = "500px";       
    
    const modalDialog = this.matDialog.open(ModalComponent, dialogConfig);
  }

  closeModal() {
    this.matDialog.closeAll();
  }
}
